const _NetworkExceptionEventData = class _NetworkExceptionEventData {
  constructor(event) {
    this.event = event;
  }
  getType() {
    return `[${this.method}/${this.code}] ${this.identity}`;
  }
  getValue() {
    return `${this.message} - ${this.endPoint}`;
  }
  getLevel() {
    if (this.status < 400) {
      return "info";
    }
    if (this.status < 500) {
      return "warning";
    }
    if (this.status === _NetworkExceptionEventData.UNKNOWN_STATUS) {
      return "warning";
    }
    return "error";
  }
  getFingerPrint() {
    return this.event.fingerprint ?? ["{{ default }}", this.method, this.code];
  }
  getExtra() {
    return this.getRawExtra(this.event);
  }
  get identity() {
    return this.getRawIdentity(this.event) ?? _NetworkExceptionEventData.UNKNOWN_IDENTITY;
  }
  get method() {
    return this.getRawMethod(this.event)?.toUpperCase() ?? _NetworkExceptionEventData.UNKNOWN_METHOD;
  }
  get endPoint() {
    return this.getRawEndPoint(this.event) ?? _NetworkExceptionEventData.UNKNOWN_URL;
  }
  get status() {
    return this.getRawStatus(this.event) ?? _NetworkExceptionEventData.UNKNOWN_STATUS;
  }
  get code() {
    const rawCode = this.getRawCode(this.event);
    return rawCode ? `${this.status}/${rawCode}` : this.status.toString();
  }
  get message() {
    return this.getRawMessage(this.event) ?? _NetworkExceptionEventData.UNKNOWN_MESSAGE;
  }
};
_NetworkExceptionEventData.UNKNOWN_IDENTITY = "Unknown Request";
_NetworkExceptionEventData.UNKNOWN_METHOD = "Unknown Method";
_NetworkExceptionEventData.UNKNOWN_URL = "Unknown URL";
_NetworkExceptionEventData.UNKNOWN_STATUS = 999;
_NetworkExceptionEventData.UNKNOWN_MESSAGE = "Unknown Error Message";
let NetworkExceptionEventData = _NetworkExceptionEventData;

export { NetworkExceptionEventData as default };
//# sourceMappingURL=NetworkEvent.mjs.map
